import remoteConfigService from './remoteConfigService'

export default remoteConfigService



// WEBPACK FOOTER //
// ../src/services/remoteConfigService/index.js